import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/categories";

const navItems = [
  { label: "首页", to: "/" },
  { label: "漫库", to: "/list" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [catOpen, setCatOpen] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/list?q=${encodeURIComponent(q)}` : "/list");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 md:px-6 py-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap font-heading text-2xl text-primary-600"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span>天天漫画网</span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) =>
            item.label === "漫库" ? (
              <div
                key={item.label}
                className="relative"
                onMouseEnter={() => setCatOpen(true)}
                onMouseLeave={() => setCatOpen(false)}
              >
                <Link
                  to={item.to}
                  className="flex items-center gap-1 rounded-md px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  {item.label}
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </Link>
                {catOpen && (
                  <div className="absolute left-0 top-full mt-2 w-52 rounded-lg border border-background-200 bg-background-50 p-2 shadow-sm">
                    {categories.map((c) => (
                      <Link
                        key={c.id}
                        to={`/list?category=${c.id}`}
                        className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
                      >
                        <i className={`${c.icon} text-primary-500`}></i>
                        {c.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={item.label}
                to={item.to}
                className="rounded-md px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </Link>
            ),
          )}
        </div>

        <form
          onSubmit={handleSearch}
          className="hidden items-center gap-0 overflow-hidden rounded-full border border-background-300 bg-background-50 lg:flex"
        >
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜漫画，想看哪部直接搜"
            className="w-56 bg-transparent px-4 py-2 text-sm outline-none"
            aria-label="搜索漫画"
          />
          <button
            type="submit"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line text-sm"></i>
          </button>
        </form>

        <button
          type="button"
          onClick={() => setOpen(!open)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={handleSearch} className="mb-3 flex items-center overflow-hidden rounded-full border border-background-300">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜漫画"
              className="w-full bg-transparent px-4 py-2 text-sm outline-none"
              aria-label="搜索漫画"
            />
            <button type="submit" aria-label="搜索" className="flex h-9 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-search-line text-sm"></i>
            </button>
          </form>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-800 hover:bg-background-100"
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-2 flex flex-wrap gap-2 px-1">
              {categories.slice(0, 5).map((c) => (
                <Link
                  key={c.id}
                  to={`/list?category=${c.id}`}
                  onClick={() => setOpen(false)}
                  className="rounded-full border border-background-300 px-3 py-1 text-xs text-foreground-600"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}